import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const ExPieChart3Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: ['feedback-count'],
  },
];
